import './styles/App.scss';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { BrowserRouter, NavLink } from "react-router-dom";
import MainMint from './MainMint.jsx';
import Navbar from './Navbar.jsx';
import About from './About.jsx';
import Roadmap from './Roadmap.jsx';
import Linkss from './Linkss.jsx';

import { useState } from "react";

export default function App() {

  
  const [accounts, setAccounts] = useState([]);
  

  return (
    
    <main className="overlay">
      <section className="App">
      
      <BrowserRouter>
        <Navbar accounts={accounts} setAccounts={setAccounts}  />
        
        
        <Routes>
        <Route path="/" element={<MainMint accounts={accounts} setAccounts={setAccounts}  />} />
        <Route path="/about" element={<About/>} />
        <Route path="/roadmap" element={<Roadmap/>} />
        <Route path="/links" element={<Linkss/>} />
        
      </Routes>
       
       
        
        </BrowserRouter>
      
    
              </section>
      <div className="movingBackground"></div>
    </main>
    
  );
}